export const OUR_SITES = {
  heading: "Research-Ready Community Clinics",
  introduction: [
    "MedCore Research collaborates with a network of research-ready community clinics strategically positioned to support high-quality clinical trials across diverse therapeutic areas. Our sites provide access to diverse and multicultural patient populations, enabling sponsors to reach representative study participants and accelerate enrollment. Collectively, our network supports more than 10,000 registered patients and over 4,000 patient visits each month across participating practices, creating a strong foundation for recruitment and retention.",
    "Each site is supported by modern clinical infrastructure, electronic medical records, secure investigational product management, and standardized quality systems. Our centralized Site Management Organization (SMO) provides responsive operational guidance and study support throughout the entire trial lifecycle, ensuring sponsors, CROs, investigators, and site teams receive timely assistance whenever needed. With ICH-GCP trained personnel, consistent oversight, and a patient-first approach, MedCore Research delivers reliable study execution, high-quality data, and successful site performance from study start-up through closeout.",
  ],
  metrics: [
    {
      value: "10,000+",
      label: "Registered patients across our network",
    },
    {
      value: "4,000+",
      label: "Patient visits each month",
    },
  ],
  strengths: [
    {
      icon: "users",
      title: "Diverse Patient Populations",
      description:
        "Access to diverse and multicultural communities supports representative participation, recruitment, and retention.",
    },
    {
      icon: "building",
      title: "Modern Clinical Infrastructure",
      description:
        "Participating sites are supported by electronic medical records, secure investigational product management, and standardized quality systems.",
    },
    {
      icon: "workflow",
      title: "Centralized SMO Support",
      description:
        "Responsive operational guidance and study support are available throughout the entire clinical trial lifecycle.",
    },
    {
      icon: "shield-check",
      title: "Quality-Focused Execution",
      description:
        "ICH-GCP trained personnel, consistent oversight, and a patient-first approach support reliable performance and high-quality data.",
    },
  ],
} as const;
